import React from 'react';
export function About() {
  return <section className="bg-cream" data-id="element-19" data-mp="flifmlndueog">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-20" data-mp="fma9ns1c04cm">
        <div className="grid items-center gap-12 lg:grid-cols-[0.82fr_1.18fr] lg:gap-20" data-id="element-21" data-mp="2prqncnvoyegb">
          <div className="relative mx-auto w-full max-w-[340px] lg:max-w-none" data-id="element-22" data-mp="2triqum689uet">
            <div className="pointer-events-none absolute -left-4 -top-4 hidden h-full w-full rounded-[22px] border border-clay/30 lg:block" aria-hidden="true" data-id="element-23" data-mp="2yt8488gxak62" />
            <img src="https://cdn.magicpatterns.com/uploads/6M8xkKvDKDdXxr4BWXGodb/CAROLINA_MENDEZ.png" alt="Retrato de Carolina Méndez, arquitecta especializada en Feng Shui" className="relative w-full rounded-[22px] object-cover shadow-lift" loading="lazy" data-id="element-24" data-mp="38q2z8hdzm2fl" />
          </div>

          <div data-id="element-25" data-mp="3hkr62bz7ns6i">
            <p className="eyebrow flex items-center gap-2.5 text-[10px] text-clay sm:text-[11px]" data-id="element-26" data-mp="3mhrcinzz2wy5">
              <span className="h-px w-6 bg-clay/50" aria-hidden="true" data-id="element-27" data-mp="3rgu71eibtkrv" />
              Detrás de la guía
            </p>

            <h2 className="mt-4 text-[32px] font-semibold leading-[1.08] tracking-[-0.015em] text-ink sm:text-[44px] lg:text-[50px]" data-id="element-28" data-mp="2lrh8vv72wf96">
              Hola, soy <span className="text-clay" data-id="element-29" data-mp="2gqt84ht1sk1r">Carolina Méndez</span>
            </h2>

            

            <p className="mt-7 text-[15.5px] leading-[1.85] text-ink-soft sm:text-[17px]" data-id="element-30" data-mp="2cqsuv0hoqewa">
              Hace algunos años mi casa se veía bien, pero{' '}
              <span className="font-medium text-ink" data-id="element-31" data-mp="34i8gosbf3xlg">no se sentía bien</span>: el dinero se me
              escapaba, mi pareja y yo cada vez hablábamos menos, y por más que ordenaba, el peso no
              se iba.
            </p>

            <p className="mt-5 text-[15.5px] leading-[1.85] text-ink-soft sm:text-[17px]" data-id="element-32" data-mp="2vntzulb8of08">
              Empecé a estudiar Feng Shui por necesidad, no por moda. Y entendí algo que cambió
              todo:{' '}
              <span className="font-medium text-clay" data-id="element-33" data-mp="3o70p8emyqjwv">
                el problema nunca fue el desorden, sino la energía
              </span>{' '}
              que circulaba —o no— en cada rincón de mi hogar. Con cambios simples y trabajando con
              cientos de mujeres con historias parecidas a la mía, ese proceso se convirtió en mi
              propio método: <span className="font-medium text-ink" data-id="element-34" data-mp="3tjpit9obkhgc">Armonía Interior</span>.
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-x-8 gap-y-4 rounded-2xl bg-sage-tint px-6 py-5" data-id="element-35" data-mp="1ebzq24hutzp">
              <p className="flex items-baseline gap-2" data-id="element-36" data-mp="3jjp2lwlqyhgd">
                <span className="font-display text-[28px] font-semibold leading-none text-clay sm:text-[32px]" data-id="element-37" data-mp="3ojthxjax5650">
                  +2.400
                </span>
                <span className="text-[13px] leading-snug text-ink-soft sm:text-[14px]" data-id="element-38" data-mp="3almu6vzoomj2">
                  mujeres ya lo aplicaron
                </span>
              </p>
              <p className="flex items-baseline gap-2" data-id="element-39" data-mp="18tqh3hxvb4m6">
                <span className="font-display text-[28px] font-semibold leading-none text-clay sm:text-[32px]" data-id="element-40" data-mp="18qufnjmt9xsz">
                  30
                </span>
                <span className="text-[13px] leading-snug text-ink-soft sm:text-[14px]" data-id="element-41" data-mp="2xd4gvz98iuq5">
                  países
                </span>
              </p>
            </div>

            <p className="mt-6 text-[15.5px] leading-[1.85] text-ink-soft sm:text-[17px]" data-id="element-42" data-mp="372nvgspx02f7">
              Y aprendí que, aunque el equilibrio general es el primer paso,{' '}
              <span className="font-medium text-ink" data-id="element-43" data-mp="3h0aglwxt4q7m">cada una tiene un área que le pesa más</span>:
              para algunas es el dinero, para otras el amor. Por eso también desarrollé un camino
              específico para cada una.
            </p>

            <blockquote className="mt-9 border-l-2 border-clay pl-6" data-id="element-44" data-mp="3pzp88zppn6tp">
              <p className="font-display text-[19px] italic leading-[1.5] text-ink sm:text-[24px]" data-id="element-45" data-mp="3l1dsy9gnc443">
                “Si reconociste algo de tu historia en la mía, empecemos por tu casa.”
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </section>;
}